import Api from '../utils/Api';

export const loginRequest = data => {
  return Api.post('auth/login', data);
};

export const sendOtp = data => {
  return Api.post('user/send-reset-otp', data);
};

export const resetPassword = data => {
  return Api.post('user/confirm-reset-otp', data);
};
